/* eslint-disable @typescript-eslint/no-unused-vars */
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext } from "contexts";
import useRewardsById from "hooks/useRewardsById";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
	Container,
	CustomButton,
	ItemImage,
	Items,
	Offer,
	OfferItem,
	OffersContainer,
	OfferText,
	RewardAmount,
	RewardItem,
	SubTitle,
	Title
} from "./styles";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";

export const FriendInviteSuccessClaimPopup = () => {
	const { getImage } = useImagePath("cdn");
	const navigate = useNavigate();
	const { close, stack } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const scale = useCalculateScale(343 + 40, 465 + 40);
	const currentPopup = [...stack]
		.reverse()
		.find(({ variant }) => variant === "friend-invite-success-claim-popup");
	const friendName =
		(currentPopup?.payload?.friendName as string) || "Your friend";

	const displayRewards = useRewardsById(
		currentPopup?.payload?.rewardId as string
	);
	const analyticsPayload = {
		event_name: "friend_invitation_accepted_dialog",
		event_type: "friend_invitation_accepted_dialog",
		source: "web_friend_referral",
		type: currentPopup?.payload?.type as string,
		reward_id: currentPopup?.payload?.rewardId as string
	};

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			...analyticsPayload,
			action: "view"
		});
	}, []);

	const onClose = (cs?: boolean) => {
		reportPlaygamiEvent("tp.web_frontend", {
			...analyticsPayload,
			action: cs ? "continue_shopping" : "close"
		});
		close({ variant: "friend-invite-success-claim-popup" });
		if (cs) {
			navigate("/shop");
		}
	};

	return (
		<Container
			scale={scale}
			$backgroundImage={getImage(
				friendCenterAssets.common.confirmPopupBackground
			)}
		>
			<CloseIconButton onClose={() => onClose(false)} />
			<div>
				<Title>
					{friendName}
					<br /> accepted your
					<br /> invitation!
				</Title>
				<SubTitle>
					Your reward items are waiting in
					<br /> your in-game inbox to be collected.
				</SubTitle>
			</div>
			<OffersContainer>
				<Offer>
					<OfferText>Your reward:</OfferText>
					<OfferItem>
						<Items>
							<RewardItem className="imgWrap" width={"25%"}>
								<ItemImage
									src={
										displayRewards?.[0]?.imageUrl ||
										displayRewards?.[0]?.overrideImageUrl
									}
									alt=""
								/>
								<div>
									<RewardAmount>
										{displayRewards?.[0]?.description}
									</RewardAmount>
								</div>
							</RewardItem>
						</Items>
					</OfferItem>
				</Offer>
			</OffersContainer>
			<CustomButton themeColor="secondary" onClick={() => onClose(true)}>
				Continue Shopping
			</CustomButton>
		</Container>
	);
};
